import { IndividualConfig } from 'ngx-toastr/toastr/toastr-config';
import { NotificationType } from 'src/app/samwebDescription/samweb/notification/notificationType';
import { RequiredAgentForSkills } from 'src/app/store/samwin/samwin-skills/required-agents-dto';
import { SkillGroup } from 'src/app/store/samwin/samwin-skills/skill-group';
import { RealTimeConnectionStatus } from 'src/app/store/server-communication/server-communication-status';
import { RequestNewOutboundCallRealTimeData } from 'src/generated/signalR/request-new-outbound-call-real-time-data';

export class ToastServerConnectionChanged {
   public static readonly type = '[NotificationToastr] Toast Server Connection Changed';

   constructor(public connectionState: RealTimeConnectionStatus, public isConnectionConfirmedByServer: boolean) {}
}

export class ToastNewRingingPhoneNotification {
   public static readonly type = '[NotificationToastr] Toast New Ringing Phone Notification';

   constructor() {}
}

export class CloseOpenRingingPhoneNotifications {
   public static readonly type = '[NotificationToastr] Close Open Ringing Phone Notifications';

   constructor() {}
}

export class ToastNewWaitingItemNotification {
   public static readonly type = '[Notificationtoastr] Toast New Waiting Item Notification';

   constructor(public skills: SkillGroup[]) {}
}

export class CloseOpenWaitingItemNotification {
   public static readonly type = '[Notificationtoastr] Close Open Waiting Item Notification';

   constructor() {}
}

export class ToastNewConfirmOutboundCallNotification {
   public static readonly type = '[NotificationToastr] Toast New Confirm Outbound Call Notification';

   constructor(public numberToDial: string) {}
}

export class CloseOpenConfirmOutboundCallNotifications {
   public static readonly type = '[NotificationToastr] Close Open Confirm Outbound Call Notifications';

   constructor(public toastId: number) {}
}

export class ToastNewAssignedMailNotification {
   public static readonly type = '[NotificationToastr] Toast New Assigned Message Notification';

   constructor() {}
}

export class CloseOpenAssignedMailNotification {
   public static readonly type = '[NotificationToastr] Close Open Assigned Message Notifications';

   constructor() {}
}

export class ToastRequireMoreAgentsNotification {
   public static readonly type = '[NotificationToastr] Toast New Require Agent Notification';

   constructor(public understaffedSkills: RequiredAgentForSkills[]) {}
}

export class CloseOpenRequireMoreAgentsNotification {
   public static readonly type = '[NotificationToastr] Close Open Require Agent Notifications';

   constructor() {}
}

export class ToastNewApplicationVersionIsAvailable {
   public static readonly type = '[NotificationToastr] Toast New Application Version Is Available';

   constructor() {}
}

export class ToastUnreachableNotification {
   public static readonly type = '[NotificationToastr] Toast User Is Unreachable';

   constructor() {}
}

export class CloseUnreachableNotification {
   public static readonly type = '[NotificationToastr] Close Open Unreachable Notifications';

   constructor() {}
}

export class UnreachableNotificationAdded {
   public static readonly type = '[NotificationToastr] Unreachable Toast Notifications Added';

   constructor(public toastId: number) {}
}

export class UnreachableNotificationRemoved {
   public static readonly type = '[NotificationToastr] Unreachable Toast Notifications Removed';

   constructor(public toastId: number) {}
}

export class RequireMoreAgentsNotificationAdded {
   public static readonly type = '[NotificationToastr] Require More Agents Toast Notifications Added';

   constructor(public toastId: number) {}
}

export class RequireMoreAgentsNotificationRemoved {
   public static readonly type = '[NotificationToastr] Require More Agents Toast Notifications Removed';

   constructor(public toastId: number) {}
}

export class ToastUserInfoNotification {
   public static readonly type = '[NotificationToastr] Toast User Info Notification';

   constructor(
      public notificationType: NotificationType,
      public titleTranslationKey: string,
      public messageTranslationKey: string,
      public toastConfig: Partial<IndividualConfig> = {}
   ) {}
}

export class RequestNewOutboundCall {
   public static readonly type = '[NotificationToastr] Request New Outbound Call';

   constructor(public requestData: RequestNewOutboundCallRealTimeData) {}
}

export class CreateNativeOutboundCallWithToastId {
   public static readonly type = '[NotificationToastr] Open Native Related to Outbound Call Toast';

   constructor(public tag: string, public toastId: number) {}
}

export class AcceptNewOutboundCallRequest {
   public static readonly type = '[NotificationToastr] Accept Request for New Outbound Call';

   constructor(public notificationId: number) {}
}

export class UpdateOutboundCallRequestContent {
   public static readonly type = '[NotificationToastr] Update Request Content for New Outbound Call';

   constructor(public notificationId: number) {}
}

export class ToastNewChatNotification {
   public static readonly type = '[NotificationToastr] Toast New Chat Notification';

   constructor() {}
}

export class AgentIsBeingLoggedOutNotification {
   public static readonly type = '[NotificationToastr] Agent Is Being Logged Out Notification';

   constructor(public timestamp: Date) {}
}

export class CloseOpenChatNotifications {
   public static readonly type = '[NotificationToastr] Close Open Chat Notifications';

   constructor() {}
}

export class RemoveSingularToast {
   public static readonly type = '[NotificationToastr] Remove Single Toast With ID';

   constructor(public toastId: number) {}
}

export class CreateNativeWithToastId {
   public static readonly type = '[NotificationToastr] Open Native Related to Toast';

   constructor(public tag: string, public toastId: number) {}
}

export class CloseNativeWithToastId {
   public static readonly type = '[NotificationToastr] Close Native Related to Toast';

   constructor(public tag: string, public toastId: number) {}
}

export class MarkRequireMoreAgentsAsClosed {
   public static readonly type = '[NotificationToastr] Mark Require More Agent Toast as Closed';

   constructor(public toastId: number) {}
}

export class MarkUnreachableAsClosed {
   public static readonly type = '[NotificationToastr] Mark Unreachable Toast as Closed';

   constructor(public toastId: number) {}
}

export class MarkAwaitingCallAsClosed {
   public static readonly type = '[NotificationToastr] Mark Awaiting Call Toast as Closed';

   constructor(public toastId: number) {}
}

export class MarkWaitingItemAsClosed {
   public static readonly type = '[NotificationToastr] mark waiting call toast as closed';

   constructor(public toastId: number) {}
}

export class MarkOutboundCallAsClosed {
   public static readonly type = '[NotificationToastr] Mark Outbound Call Toast as Closed';

   constructor(public toastId: number) {}
}

export class MarkAwaitingChatAsClosed {
   public static readonly type = '[NotificationToastr] Mark Awaiting Chat Toast as Closed';

   constructor(public toastId: number) {}
}

export class MarkAwaitingMessageAsClosed {
   public static readonly type = '[NotificationToastr] Mark Awaiting Message Toast as Closed';

   constructor(public toastId: number) {}
}

export class MarkAsClosedByTag {
   public static readonly type = '[NotificationToastr] Mark Toast as Closed by Native Tag';

   constructor(public tag: string, public toastId: number) {}
}
